import type { CSSObject } from '@mantine/core';
import { createStyles, getStylesRef } from '@mantine/core';
import { transition } from '@repo/theme/primitives';
import { ENTITY_NODE_HEADER_HEIGHT } from '../EntityNodeHeader/EntityNodeHeader.constants';
import {
	ENTITY_NODE_CONTAINER_WIDTH,
	ENTITY_NODE_WIDTH,
} from './EntityNode.constants';

interface EntityNodeStylesProps {
	selected: boolean;
	createAccess?: boolean;
}

export const useStyles = createStyles(
	(theme, { selected, createAccess }: EntityNodeStylesProps) => ({
		container: {
			width: ENTITY_NODE_CONTAINER_WIDTH,
			'&:hover': {
				[`& .${getStylesRef('handleLeft')}`]: {
					opacity: createAccess ? 1 : 0,
				},
				[`& .${getStylesRef('handleRight')}`]: {
					opacity: createAccess ? 1 : 0,
				},
			},
		},
		wrapper: {
			backgroundColor: theme.other.getColor('surface/primary/default'),
			flexWrap: 'nowrap',
			justifyContent: 'space-between',
			width: ENTITY_NODE_WIDTH,
			height: 'fit-content',
			boxShadow: selected
				? `0px 0px 0px 2px ${theme.other.getColor('border/emphasis/default')}`
				: theme.shadows.sm,
			borderRadius: theme.radius.md,
			overflow: 'hidden',
			gap: 0,
		},
		content: {
			flexGrow: '1 !important' as CSSObject['flexGrow'],
			gap: 0,
		},
		handle: {
			opacity: 0,
			top: `${ENTITY_NODE_HEADER_HEIGHT / 2}px !important`,
			borderColor: 'transparent !important',
			...transition('duration-300', 'easeOut')('opacity'),
		},
		handleLeft: {
			ref: getStylesRef('handleLeft'),
			left: createAccess
				? '0px !important'
				: `${theme.other.space[4]}px !important`,
			opacity: 0,
			...transition('duration-300', 'easeOut')('opacity'),
		},
		handleRight: {
			ref: getStylesRef('handleRight'),
			right: createAccess
				? '0px !important'
				: `${theme.other.space[4]}px !important`,
			opacity: 0,
			...transition('duration-300', 'easeOut')('opacity'),
		},
	})
);
